// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rendered-events{height:calc(100% - 1.3rem);padding-left:0.5rem;font-size:1.1rem;position:relative;z-index:1}@media (min-width: 768px){.rendered-events{font-size:1.1rem;height:calc(100% - 1.8rem)}}.rendered-events .styled-event{text-align:left;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;padding-top:0.1rem}@media (min-width: 768px){.rendered-events .styled-event{padding-top:0.2rem}}.rendered-events .more-events{text-align:right}\n", ""]);
// Exports
module.exports = exports;
